import { render, staticRenderFns } from "./characters.vue?vue&type=template&id=a0ed25bc&scoped=true&"
import script from "./characters.vue?vue&type=script&lang=js&"
export * from "./characters.vue?vue&type=script&lang=js&"
import style0 from "./characters.vue?vue&type=style&index=0&id=a0ed25bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ed25bc",
  null
  
)

export default component.exports